<template>
    <card title="Compound Drug">
        <div v-if="!isLoading">
            <b-row class="pb-1 align-items-center">
                <b-col>
                    <SearchComponent v-model="drugSearch" :label="`Drug`" :params="{ onlyActive: false }"
                        :search-u-r-l="`/Compound`" @input="onDrugSelected">
                    </SearchComponent>
                </b-col>
                <b-col cols="2">
                    <b-button :block="true" variant="danger" @click="clearClicked">
                        Clear
                    </b-button>
                </b-col>
            </b-row>
            <b-button variant="info" @click="onNewBrand">
                New Compound
            </b-button>
            <hr>

            <b-row v-show="drugName" class="text-center">
                <b-col>
                    <h2>{{ drugName }}</h2>
                </b-col>
            </b-row>
            <b-row v-show="drug && drug.compoundID" class="py-2">
                <b-col v-if="!editBrandForm">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h1 class="card-subtitle"> {{ brandTitle }} </h1>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                            <b-col class="text-right">
                                <b-button
                                    variant="info"
                                    size="sm"
                                    class="mr-2"
                                    @click="onManageEquivalents"
                                >
                                    <i class="fas fa-link"></i> Manage Equivalents
                                </b-button>
                                <a href="#" @click.prevent="onEditBrand">
                                    <span>Edit</span> <i class="fa fa-edit" />
                                </a>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="brandfiller" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>CompoundID: </strong>{{ drug.compoundID }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{ drug && drug.ndc }}
                            </b-col>
                        </b-row>
                        <b-row v-if="drug && drug.labelName">
                            <b-col>
                                <strong>Label Name: </strong>{{ drug.labelName }}
                                <small class="text-muted"> (Used for printing)</small>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>AWP: </strong>{{ awp }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{ packageSize }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit of Measure: </strong>{{ unitOfMeasure }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Minimum Dispense Quantity: </strong>{{ minimumDispenseQuantity }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{ deaClass }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Instructions: </strong>{{ instructions }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Dosage Form: </strong>{{ dosageForm }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Route of Administration: </strong>{{ routeOfAdministration }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Compound Type: </strong>{{ compoundType }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Level of Effort: </strong>{{ levelOfEffort }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Status: </strong>{{ status }}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>
                <b-col v-if="editBrandForm">
                    <CompoundFormComponent :drug="drugEdit" :form-section="`Drug`" @close="editBrandForm = false"
                        @continue="onBrandFormContinue"></CompoundFormComponent>
                </b-col>
                <b-col v-if="!editPatEdForm">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h1 class="card-subtitle"> {{ patEdTitle }} </h1>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                            <b-col class="text-right">
                                <a href="#" @click.prevent="onEditPatEd">
                                    <span>Edit</span> <i class="fa fa-edit" />
                                </a>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="patedfiller1" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Description: </strong>{{ patEdDescription }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Contraindications: </strong>{{ patEdContraindications }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Administration: </strong>{{ patEdAdministration }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Missed Dose Instructions: </strong>{{ patEdMissedDoseInstructions }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Monitoring: </strong>{{ patEdMonitoring }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Side Effects: </strong>{{ patEdSideEffects }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Storage: </strong>{{ patEdStorage }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="patedfiller2" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                    </card>
                </b-col>
                <b-col v-if="editPatEdForm">
                    <CompoundFormComponent :drug="drugEdit" :form-section="`PatEd`" @close="editPatEdForm = false"
                        @continue="onPatEdFormContinue"></CompoundFormComponent>
                </b-col>
            </b-row>

            <div v-show="drug && drug.compoundID">
                <hr>
                <!-- Ingredients -->
                <b-row class="md-5">
                    <b-col>
                        <Ingredients :compound-id="drug.compoundID" :ingredients="ingredients"
                            @cancel="checkFormDataModified" @continue="checkFormDataModified"
                            @delete="checkFormDataModified">
                        </Ingredients>
                    </b-col>
                </b-row>
            </div>

            <div v-show="drug && drug.compoundID">
                <hr>
                <!-- WARNINGLABELS -->
                <b-row class="md-5">
                    <b-col>
                        <WarningLabels :product-id="drug.compoundID" :warningLabels="warningLabels"
                            @cancel="checkFormDataModified" @continue="checkFormDataModified"
                            @delete="checkFormDataModified">
                        </WarningLabels>
                    </b-col>
                </b-row>
            </div>
            <div v-show="drug && drug.compoundID">
                <hr>
                <!-- PREPARATION STEPS -->
                <b-row class="md-5">
                    <b-col>
                        <PreparationSteps :compound-id="drug.compoundID" :steps="steps"
                            @cancel="checkFormDataModified" @continue="checkFormDataModified"
                            @delete="checkFormDataModified">
                        </PreparationSteps>
                    </b-col>
                </b-row>
            </div>
            <div v-show="drug && drug.compoundID > 0">
                <hr>
                <!-- INVENTORY -->
                <b-row class="md-5" id="inventory">
                    <b-col>
                        <InventoryComponent :drug-source="2" :billing-unit="drug.unitOfMeasure"
                            :inventories="inventories" :package-id="drug.compoundID"
                            @removed="fetchInventories" @update="fetchInventories" />
                    </b-col>
                </b-row>
            </div>
            <div v-show="drug && drug.drugId">
                <hr />
                <b-row class="md-5">
                    <b-col>
                        <h5>Alert</h5>
                        <b-row class="py-2">
                            <b-col>
                                <b-form-textarea v-model="alert" class="textarea-autosize"></b-form-textarea>
                            </b-col>
                            <b-col cols="3">
                                <b-button :block="true" variant="success" @click="saveAlert">
                                    Save Alert
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <div v-show="drug && drug.drugId != -1">
                    <h4>Drug Documents</h4>
                    <DrugDocumentsComponent :drugId="drug.drugId" :drugSource="2" name="drugDocument" />
                </div>
                <b-col class="text-center" cols="12">
                    <b-button :disabled="!formDataModified" variant="success" @click="onSaveClicked">
                        Save Changes
                    </b-button>
                    <b-button @click="onCancelClicked">Cancel</b-button>
                    <b-button v-if="drug && drug.compoundID" variant="primary" @click="prepareCompound" class="ml-2">
                        <i class="fas fa-flask"></i> Prepare Compound
                    </b-button>
                    <b-button v-if="drug && drug.compoundID" variant="info" @click="viewBatchHistory" class="ml-2">
                        <i class="fas fa-history"></i> View Batch History
                    </b-button>
                </b-col>
            </div>

        </div>

        <!-- Manage Equivalents Modal -->
        <ManageEquivalentsModal
            modal-id="manage-equivalents-modal"
            :current-compound="drug"
        />
    </card>
</template>

<script lang="ts">
import SearchComponent from '@/components/SearchComponent.vue';
import CompoundFormComponent from '@/components/Compound/CompoundFormComponent.vue';
import GSDDMergeModalComponent from '@/components/NonGSDD/GSDDMergeModalComponent.vue';
import WarningLabels from '@/components/Compound/WarningLabels.vue';
import PreparationSteps from '@/components/Compound/PreparationSteps.vue';
import InventoryComponent from '@/components/Inventory/InventoryComponent.vue';
import { Inventory } from '@/models/Inventory';
import Ingredients from '@/components/Compound/Ingredients.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    CompoundDrug,
    CompoundIngredients,
    CompoundPatEd,
    CompoundWarningLabels,
    CompoundSteps,
    CompoundDosageForm,
    CompoundType,
    CompoundLevelOfEffort,
    CompoundLevelOfEffortDisplayNames
} from '@/models/Drug/CompoundDrug';
import Axios, { AxiosError } from "axios";
import { DrugSource } from "@/models/Drug/DrugProduct";
import { DrugStatus } from "@/models/Drug/Drug";
import DrugStatusEnum = DrugStatus.DrugStatusEnum;
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

import DrugDocumentsComponent from '@/components/Drug/DrugDocumentsComponent.vue'
import ManageEquivalentsModal from '@/components/Compound/ManageEquivalentsModal.vue'

@Component({
    name: "CompoundDrugDetailsPage",
    components: {
        SearchComponent,
        Ingredients,
        WarningLabels,
        PreparationSteps,
        CompoundFormComponent,
        GSDDMergeModalComponent,
        DrugDocumentsComponent,
        InventoryComponent,
        ManageEquivalentsModal
    }
})
export default class CompoundDrugDetailsPage extends Vue {
    private isLoading = false;
    private drugSearch: CompoundDrug = new CompoundDrug();
    private drugOriginal: CompoundDrug = new CompoundDrug();
    private drug: CompoundDrug = new CompoundDrug();
    private drugEdit: CompoundDrug = new CompoundDrug();
    private status: string | null = null;
    private patEd: CompoundPatEd = new CompoundPatEd();
    private warningLabels: CompoundWarningLabels[] = [];
    private ingredients: CompoundIngredients[] = [];
    private steps: CompoundSteps[] = [];
    protected inventories: Inventory[] = [];
    private brandTitle: string = "Brand";
    private patEdTitle: string = "Patient Education";
    private editBrandForm: boolean = false;
    private editPatEdForm: boolean = false;
    private formDataModified: boolean = false;
    private alert = "";

    get routeDrugId(): number {
        let res = parseInt(this.$route.params.id);
        if (isNaN(res)) return 0;
        return res;
    }

    get drugSource(): DrugSource {
        return DrugSource.CompoundProduct;
    }

    // from Product
    get drugName(): any {
        if (!this.drug) return ``;
        return this.drug.name;
    }

    get awp(): any {
        if (!this.drug || !this.drug.awp) return ``;
        return `${this.drug.awp}`;
    }

    get packageSize(): any {
        if (!this.drug || !this.drug.packageSize) return ``;
        return `${this.drug.packageSize}`;
    }

    get unitOfMeasure(): any {
        if (!this.drug) return ``;
        return this.drug.unitOfMeasure;
    }

    get minimumDispenseQuantity(): any {
        if (!this.drug || !this.drug.minimumDispenseQuantity) return ``;
        return `${this.drug.minimumDispenseQuantity}`;
    }

    get deaClass(): any {
        if (!this.drug) return ``;
        return this.drug.deaClass;
    }

    get instructions(): any {
        if (!this.drug) return ``;
        return this.drug.instructions;
    }

    get dosageForm(): any {
        if (!this.drug || this.drug.dosageForm === null || this.drug.dosageForm === undefined) return `Not Specified`;
        return CompoundDosageForm[this.drug.dosageForm];
    }

    get routeOfAdministration(): any {
        if (!this.drug || !this.drug.routeOfAdministration) return `Not Specified`;
        return this.drug.routeOfAdministration;
    }

    get compoundType(): any {
        if (!this.drug || this.drug.compoundType === null || this.drug.compoundType === undefined) return `Not Specified`;
        return CompoundType[this.drug.compoundType];
    }

    get levelOfEffort(): any {
        if (!this.drug || this.drug.levelOfEffort === null || this.drug.levelOfEffort === undefined) return `Not Specified`;
        const displayName = CompoundLevelOfEffortDisplayNames.find(d => d.enum === this.drug.levelOfEffort);
        return displayName ? displayName.name : CompoundLevelOfEffort[this.drug.levelOfEffort];
    }

    get patEdDescription(): any {
        if (!this.drug.patEd || !this.drug.patEd.description) return ``;
        return this.drug.patEd.description;
    }

    get patEdContraindications(): any {
        if (!this.drug.patEd || !this.drug.patEd.contraindications) return ``;
        return this.drug.patEd.contraindications;
    }

    get patEdAdministration(): any {
        if (!this.drug.patEd || !this.drug.patEd.administration) return ``;
        return this.drug.patEd.administration;
    }

    get patEdMissedDoseInstructions(): any {
        if (!this.drug.patEd || !this.drug.patEd.missedDoseInstructions) return ``;
        return this.drug.patEd.missedDoseInstructions;
    }

    get patEdMonitoring(): any {
        if (!this.drug.patEd || !this.drug.patEd.monitoring) return ``;
        return this.drug.patEd.monitoring;
    }

    get patEdSideEffects(): any {
        if (!this.drug.patEd || !this.drug.patEd.sideEffects) return ``;
        return this.drug.patEd.sideEffects;
    }

    get patEdStorage(): any {
        if (!this.drug.patEd || !this.drug.patEd.storage) return ``;
        return this.drug.patEd.storage;
    }

    get ncpdBillingUnit(): string {
        return this.drug ? this.drug.unitOfMeasure : ``;
    }

    created() {
        if (this.routeDrugId) {
            this.fetchDrug(this.routeDrugId);
        }
    }

    @Watch('$route.params.id')
    onParamChanged(value: string, oldValue: string) {
        if (value != oldValue) {
            this.fetchDrug(Number(value))
        }
    }

    @Watch('drug')
    onDrugChanged(value: CompoundDrug | null, oldValue: CompoundDrug | null) {
        if (!value || value.compoundID == oldValue?.compoundID) return;

        if (value.compoundID && value.compoundID != -1 && value.compoundID != this.routeDrugId) {
            this.$router.push({ name: 'Compound-Drug', params: { id: value.compoundID.toString() } });
        }
    }

    async clearClicked() {
        let ignoreFormDataModified = false;
        if (this.formDataModified) {
            ignoreFormDataModified = await this.confirmIgnoreFormDataModified();
            if (!ignoreFormDataModified) return;
            this.formDataModified = false;
        }
        this.drugSearch = new CompoundDrug();
        this.drug = new CompoundDrug();
        await this.$router.push({ name: 'Compound-Drug-New' });
    }

    async onDrugSelected(drug: CompoundDrug) {
        let ignoreFormDataModified: boolean = false;
        if (this.formDataModified) {
            ignoreFormDataModified = await this.confirmIgnoreFormDataModified();
            if (!ignoreFormDataModified) return;
            this.formDataModified = false;
        }
        this.editBrandForm = false;
        this.editPatEdForm = false;
        //this.clearClicked();
        this.status = null;
        this.ingredients = [];
        this.warningLabels = [];
        this.steps = [];
        const compoundId = Number(drug.compoundID || 0);
        this.fetchDrug(compoundId);
    }

    async fetchDrug(compoundID: number) {
        if (!compoundID || compoundID == -1) {
            this.drug = new CompoundDrug();
            return;
        }

        try {
            const response = await Axios.get<CompoundDrug>(`/Compound/${compoundID}`);

            const drug = response.data;
            this.drug = new CompoundDrug(drug.compoundID, drug);
            if (drug.patEd) this.drug.patEd = new CompoundPatEd(drug.patEd);
            this.status = DrugStatusEnum[drug.activeStatus];
            if (drug.ingredients) this.ingredients = Object.assign(new Array<CompoundIngredients>(), drug.ingredients);
            this.fetchInventories();
            if (drug.warningLabels) this.warningLabels = Object.assign(new Array<CompoundWarningLabels>(), drug.warningLabels);
            await this.fetchSteps(compoundID);

            try {
                const alertResponse = await Axios.get(`/Drug/${drug.drugId}/Alert`, { params: { drugSource: drug.source } });
                this.alert = alertResponse.data;
            } catch (error) {
                console.error('There was an error while getting Alerts', {
                    error,
                    response: (error as AxiosError)?.response
                });
                this.$notification(NotificationOptions.error(error));
            }
        } catch (error) {
            console.error('Problem while getting drug details.', { error, response: (error as AxiosError)?.response });
            this.$notification(NotificationOptions.error(error));
        }

        this.isLoading = false;
        this.drugOriginal = new CompoundDrug(null, this.drug);
        this.drugOriginal.patEd = new CompoundPatEd();
        this.drugOriginal.ingredients = new Array<CompoundIngredients>();
        this.drugOriginal.warningLabels = new Array<CompoundWarningLabels>();
        this.drugOriginal.steps = new Array<CompoundSteps>();
        if (this.drug.patEd) this.drugOriginal.patEd = new CompoundPatEd(this.drug.patEd);
        if (this.drug.ingredients) this.drugOriginal.ingredients = this.drug.ingredients;
        if (this.drug.warningLabels) this.drugOriginal.warningLabels = this.drug.warningLabels;
        if (this.drug.steps) this.drugOriginal.steps = this.drug.steps;
    }


    fetchInventories() {
        if (!this.drug?.compoundID) return;

        this.$http.get(`/Drug/${this.drug.compoundID}/Inventory`, {
            params: { drugSource: 2 }
        })
            .then(response => {
                this.inventories = response.data;
            })
            .catch(error => {
                console.error('There was an error while getting Inventory', { error, response: error?.response });
            });
    }

    async fetchSteps(compoundID: number) {
        if (!compoundID) return;

        try {
            const response = await Axios.get<CompoundSteps[]>(`/Compound/${compoundID}/steps`);
            this.steps = response.data || [];
        } catch (error) {
            console.error('There was an error while getting compound steps', { error, response: (error as AxiosError)?.response });
            this.$notification(NotificationOptions.error(error));
        }
    }

    async saveSteps() {
        if (!this.drug?.compoundID) return;

        try {
            await Axios.post(`/Compound/${this.drug.compoundID}/steps`, this.steps);
            this.$notification(NotificationOptions.success('Preparation steps saved successfully'));
        } catch (error) {
            console.error('There was an error while saving compound steps', { error, response: (error as AxiosError)?.response });
            this.$notification(NotificationOptions.error(error));
        }
    }

    onEditBrand() {
        this.drugEdit = new CompoundDrug(null, this.drug);
        this.editBrandForm = true;
    }

    onManageEquivalents() {
        this.$bvModal.show('manage-equivalents-modal');
    }

    onEditPatEd() {
        this.drugEdit = new CompoundDrug(null, this.drug);
        this.drugEdit.patEd = Object.assign(new CompoundPatEd(), this.drug.patEd);
        this.editPatEdForm = true;
    }

    onBrandFormContinue() {
        this.drug = new CompoundDrug(null, this.drugEdit);
        this.status = DrugStatusEnum[this.drugEdit.activeStatus];
        this.drug.patEd = new CompoundPatEd(this.drugEdit.patEd);
        this.editBrandForm = false;
        this.checkFormDataModified();
    }

    onPatEdFormContinue() {
        this.drug = new CompoundDrug(null, this.drugEdit);
        this.status = DrugStatusEnum[this.drugEdit.activeStatus];
        this.drug.patEd = new CompoundPatEd(this.drugEdit.patEd);
        this.editPatEdForm = false;
        this.checkFormDataModified();
    }

    async onNewBrand() {
        let ignoreFormDataModified: boolean = false;
        if (this.formDataModified) {
            ignoreFormDataModified = await this.confirmIgnoreFormDataModified();
            if (!ignoreFormDataModified) return;
        }
        this.formDataModified = false;
        this.drug = new CompoundDrug(-1);
        this.drug.patEd = new CompoundPatEd();
        this.drug.ingredients = new Array<CompoundIngredients>();
        this.drug.warningLabels = new Array<CompoundWarningLabels>();
        this.drugEdit = new CompoundDrug(null, this.drug);
        this.drugOriginal = new CompoundDrug(null, this.drug);
        this.drugOriginal.patEd = new CompoundPatEd();
        this.drugOriginal.ingredients = new Array<CompoundIngredients>();
        this.drugOriginal.warningLabels = new Array<CompoundWarningLabels>();
        this.drugOriginal.steps = new Array<CompoundSteps>();
        this.ingredients = new Array<CompoundIngredients>();
        this.warningLabels = new Array<CompoundWarningLabels>();
        this.steps = new Array<CompoundSteps>();
        this.onEditBrand();
        this.onEditPatEd();
    }

    async onSaveClicked() {
        if (this.ingredients.length == 0) {
            await this.$bvModal.msgBoxOk(`Compound can not be saved without any ingredients`);
            return;
        }
        let fetchByNdcResults: CompoundDrug[] = [];
        let sc: number = 0;
        let scGood: number[] = [200, 204];
        if ((this.drugOriginal.ndc && this.drug.ndc != this.drugOriginal.ndc) || !this.drugOriginal.ndc) {
            const value = await this.fetchByNdc(this.drug.ndc);

            if (value.length == null) {
                sc = value;
            }
            else {
                sc = value[0];
                fetchByNdcResults = value[1];
            }

            if (!scGood.includes(sc)) {
                await this.$bvModal.msgBoxOk(`Database error occurred while attempting to verify new NDC`);
                return;
            }
        }
        let ignoreDuplicateNdc: boolean = false;
        if (sc == 200 && fetchByNdcResults.map(item => item.ndc).includes(this.drug.ndc)) {
            ignoreDuplicateNdc = await this.confirmIgnoreDuplicateNdc(this.drug.ndc);
            if (!ignoreDuplicateNdc) return;
        }
        this.drug.ingredients = this.ingredients;
        this.drug.warningLabels = this.warningLabels;
        this.drug.steps = this.steps;
        let newCompoundID: number = -1;
        const value = await this.dbSave(this.drug);

        if (!Array.isArray(value)) {
            sc = Number(value);
        }
        else {
            sc = Number(value[0]);
            newCompoundID = value[1];
        }

        if (sc === 403) {
            await this.$bvModal.msgBoxOk(`You do not have permissions for this action. Compound Manager must be assigned to user.`);
            return;
        }
        if (sc != 200) {
            await this.$bvModal.msgBoxOk(`Database error occurred while attempting to save data`);
            return;
        }

        // Update compound ID before saving steps (needed for new compounds)
        if (newCompoundID > 0) this.drug.compoundID = newCompoundID;

        // Save steps after compound ID is set
        await this.saveSteps();

        this.formDataModified = false;
        this.ingredients = [];
        this.warningLabels = [];
        await this.onDrugSelected(this.drug);
        await this.$bvModal.msgBoxOk(`Data saved successfully`);
        return;
    }

    async onCancelClicked() {
        let ignoreFormDataModified: boolean = false;
        if (this.formDataModified) {
            ignoreFormDataModified = await this.confirmIgnoreFormDataModified();
            if (!ignoreFormDataModified) return;
            this.formDataModified = false;
        }
        this.drug = new CompoundDrug(null, this.drugOriginal);
        this.status = DrugStatusEnum[this.drugOriginal.activeStatus];
        this.drug.patEd = new CompoundPatEd(this.drugOriginal.patEd);
        this.drug.ingredients = Object.assign(new Array<CompoundIngredients>(), this.drugOriginal.ingredients);
        this.drug.warningLabels = Object.assign(new Array<CompoundWarningLabels>(), this.drugOriginal.warningLabels);
        this.drug.steps = Object.assign(new Array<CompoundSteps>(), this.drugOriginal.steps);
        this.ingredients = Object.assign(new Array<CompoundIngredients>(), this.drugOriginal.ingredients);
        this.warningLabels = Object.assign(new Array<CompoundWarningLabels>(), this.drugOriginal.warningLabels);
        this.steps = Object.assign(new Array<CompoundSteps>(), this.drugOriginal.steps);
        this.editBrandForm = false;
        this.editPatEdForm = false;
        this.formDataModified = false;
        return;
    }

    prepareCompound() {
        if (!this.drug || !this.drug.compoundID) return;

        // Navigate to compound filling page with compound pre-selected
        this.$router.push({
            name: 'CompoundFillingPage',
            params: {
                compoundId: this.drug.compoundID.toString(),
                mode: 'batch'
            }
        });
    }

    viewBatchHistory() {
        if (!this.drug || !this.drug.compoundID) return;

        // Navigate to batch audit page for this compound
        this.$router.push({
            name: 'CompoundBatchAudit',
            params: {
                compoundId: this.drug.compoundID.toString()
            }
        });
    }

    checkFormDataModified() {
        const drugsMatch = JSON.stringify(this.drugOriginal) == JSON.stringify(this.drug);
        const ingredientsMatch = JSON.stringify(this.drugOriginal.ingredients) == JSON.stringify(this.ingredients);
        const warningLabelsMatch = JSON.stringify(this.drugOriginal.warningLabels) == JSON.stringify(this.warningLabels);
        const stepsMatch = JSON.stringify(this.drugOriginal.steps) == JSON.stringify(this.steps);
        const allMatch = (drugsMatch && ingredientsMatch && warningLabelsMatch && stepsMatch);
        this.formDataModified = !allMatch;
    }

    async confirmIgnoreFormDataModified(): Promise<boolean> {
        try {
            const value = await this.$bvModal.msgBoxConfirm(`Data has been modified. New search selection, or Clicking 'New Drug', Clear buttons will not save data - Are you sure?`, {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            });
            return value == null ? false : value;
        } catch (err) {
            console.error("Error caught on New Drug or Clear button.", err);
            return false;
        }
    }

    async confirmIgnoreDuplicateNdc(ndc: string): Promise<boolean> {
        try {
            const value = await this.$bvModal.msgBoxConfirm(`NDC: ${ndc} - already exist! - Are you sure?`, {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            });
            return value == null ? false : value;
        } catch (err) {
            console.error("Error caught on verify duplicate NDC.", err);
            return false;
        }
    }

    async fetchByNdc(ndc: string): Promise<[number, Array<CompoundDrug>] | any> {
        try {
            const response = await Axios.get(`/Compound/ndc/${ndc}`);
            const drugNdc: CompoundDrug[] = response.data;
            const sc: number = Number(response.status);
            return [sc, drugNdc];
        } catch (error) {
            const err = error as AxiosError;
            console.error('Error while getting CompoundDrug ByNdc.', { error, response: err?.response });
            this.$notification(NotificationOptions.error(error));
            return err.response?.status;
        }
    }

    async dbSave(drug: CompoundDrug): Promise<[number, number] | number | undefined> {
        this.isNullPatEd(drug.patEd);
        console.log("drug = ", drug);
        try {
            const response = await Axios.post('/Compound', drug, { params: { bypassDuplicateCheck: true } });
            const sc: number = Number(response.status);
            let drugResponse = response.data;
            const newCompoundID: number = drugResponse.compoundID!;
            return [sc, newCompoundID];
        } catch (error) {
            const errorMsg = "Error while saving CompoundDrug";
            const err = error as AxiosError;
            console.error(errorMsg, { error, response: err?.response });
            this.$notification(NotificationOptions.error(error));
            return err.response?.status;
        }
    }

    isNullPatEd(patEd: CompoundPatEd) {
        if (patEd.description == null) patEd.description = "";
        if (patEd.contraindications == null) patEd.contraindications = "";
        if (patEd.administration == null) patEd.administration = "";
        if (patEd.missedDoseInstructions == null) patEd.missedDoseInstructions = "";
        if (patEd.monitoring == null) patEd.monitoring = "";
        if (patEd.sideEffects == null) patEd.sideEffects = "";
        if (patEd.storage == null) patEd.storage = "";
    }

    async saveAlert() {
        if (!this.alert.length) return;
        if (!this.drug || !this.drug.drugId) return;

        try {
            const response = await Axios.post(`/Drug/${this.drug.drugId}/Alert`, { body: this.alert }, { params: { drugSource: this.drug.source } });

            this.alert = response.data;
            this.$notification(NotificationOptions.successSaveNotificationPreset("Alert"));
        } catch (error) {
            console.error('There was an error while updating alert', { error, response: (error as AxiosError)?.response });
            this.$notification(NotificationOptions.error(error));
        }
    }

}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
::v-deep .modal-dialog {
    right: 0;
    position: absolute;
}
</style>
